import { findGetParameter } from "./urlParams";

export function isAppMode() {
  const hasAppPath = (url) => {
    try {
      const urlObject = new URL(url);
      const pathSegments = urlObject.pathname.split("/");

      return pathSegments.includes("app");
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  if (
    findGetParameter("appMode") === "true" ||
    sessionStorage?.getItem("appMode") ||
    hasAppPath(window.location.href)
  ) {
    return true;
  } else if (document?.referrer) {
    hasAppPath(document.referrer);
  } else {
    return false;
  }
}

export function utf8ToBase64(string) {
  // Browser logic
  if (typeof window !== "undefined") {
    const utf8Bytes = new TextEncoder().encode(string);
    let binary = "";
    utf8Bytes.forEach((byte) => (binary += String.fromCharCode(byte)));
    return window.btoa(binary);
  } else {
    // Node.js/incompatible browser fallback
    return Buffer.from(string, "utf8").toString("base64");
  }
}

export function base64ToUtf8(string) {
  // Browser logic
  if (typeof window !== "undefined") {
    const binary = window.atob(string);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
  } else {
    // Node.js/incompatible browser fallback
    return Buffer.from(string, "base64").toString("utf8");
  }
}
